export default function PersonIcon() {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4117 5.07587C11.4117 7.52339 9.44926 9.48591 7.00001 9.48591C4.55159 9.48591 2.58836 7.52339 2.58836 5.07587C2.58836 2.62834 4.55159 0.666656 7.00001 0.666656C9.44926 0.666656 11.4117 2.62834 11.4117 5.07587ZM7.00001 17.3333C3.38532 17.3333 0.333344 16.7458 0.333344 14.4791C0.333344 12.2116 3.4045 11.6449 7.00001 11.6449C10.6155 11.6449 13.6667 12.2324 13.6667 14.4991C13.6667 16.7667 10.5955 17.3333 7.00001 17.3333Z"
        fill="#9E9E9E"
      />
    </svg>
  );
}
